import React from "react";
import { Box, SimpleGrid } from "@chakra-ui/react";
import { Section } from "components/section";
import { HeroSpotlightBackgroundEffects } from "components/hero";
import { TextTitle } from "ui/text";
import { CodeIcon, ExperimentsIcon, LayoutIcon, MegaphoneIcon } from "ui/icons";
import { JumpLinkCard } from "./jump-link-card";

export function LearnHero({ title }: { title: string }) {
  return (
    <Section
      theme="dark"
      themeBgColor="new.blue.950"
      bg="new.blue.950"
      pos="relative"
      overflow="hidden"
      pt={{ base: "biggest", md: "huge", lg: "huger" }}
      pb={{ base: "huge", md: "huger" }}
    >
      <HeroSpotlightBackgroundEffects
        theme="dark"
        bgColor="new.blue.950"
        spotlightColor="new.blue.900"
        spotlightHeight={{ base: "190%", md: "100%" }}
      />

      <Box pos="relative">
        <TextTitle align="center" size="2xl" theme="dark" titleAs="h1" title={title} maxW="680px" />

        <SimpleGrid
          justifyContent="stretch"
          display={{ base: "none", md: "grid" }}
          columns={4}
          mt={{ base: "biggest", lg: "huge" }}
          gap="smaller"
        >
          <JumpLinkCard
            icon={ExperimentsIcon}
            iconColor="green"
            title="Marketing technology"
            href="#marketing-technology"
          />
          <JumpLinkCard icon={MegaphoneIcon} iconColor="blue" title="For marketers" href="#marketers" />
          <JumpLinkCard
            icon={CodeIcon}
            iconColor="violet"
            title="For data and analytics engineers"
            href="#data-and-analytics"
          />
          <JumpLinkCard icon={LayoutIcon} iconColor="yellow" title="For advertisers" href="#advertisers" />
        </SimpleGrid>
      </Box>
    </Section>
  );
}
